// Port of api/fuel/app/classes/filter/search/games/filters/query/play/subset.php
export default {
	name: 'play.subset',
	priority: 3,
	require: function(config, filter) { return filter.play && filter.play.subset && filter.play.subset.length > 0 },
	run: function(config, filter, data, query) {
		query.where('p.play_id', 'in', filter.play.subset)
	}
}
